<template>
	<div class="pc-user-skeleton-shell">
		<div class="pc-user-skeleton-shell__layout pc-center-1200">
			<PageSkeleton />
		</div>
	</div>
</template>

<script setup>
import PageSkeleton from "./index.vue";
</script>

<style lang="scss" scoped>
.pc-user-skeleton-shell {
	box-sizing: border-box;
	min-height: 780px;
	height: 100%;
	padding: 30px 0 0;
	background: #ffffff;
}

.pc-user-skeleton-shell__layout {
	padding-bottom: 64px;
}
</style>
